<template>
    <div class="flex-image-container">
        <div
            @dragover.prevent="handleDragOver"
            @dragleave.prevent="handleDragLeave"
            @dragenter.prevent="handleDragOver"
            @drop="handleDrop"
            :class="{'drag-over': isDragging}"
        >
            <label
                :for="`image-${key}`"
                class="btn-image ma-2"
            >Nova Imagem</label>
            <input
                type="file"
                accept="image/*"
                :ref="`image-${key}`"
                :id="`image-${key}`"
                :name="`image-${key}`"
                @input="uploader"
            >
        </div>
        <div>
            <v-img
                class="ma-1"
                contain
                max-width="160"
                v-if="getUrl()"
                :src="getUrl()"
                style="border-radius: 8px;"
            />
            <div v-if="getUrl()" class="d-flex mb-2" style="gap: 8px;">
                <v-btn
                    color="red"
                    class="white--text"
                    @click.native="clear"
                    small
                >
                    Excluir
                </v-btn>
                <v-btn
                    color="primary"
                    outlined
                    small
                    @click="baixar"
                >
                    <v-icon small left>mdi-download</v-icon>
                    Baixar
                </v-btn>
            </div>
        </div>
    </div>
</template>

<script>
import auth from '@/utils/auth';
import { resize } from '@/utils/image';

export default {
    name: 'ImageInput',

    props: {
        value: {
            type: Object,
        },
        autoResize: {
            type: Boolean,
            default: true,
        },
        // Nome do arquivo baixado (sem extensão); sem ele, usa o nome original da imagem
        nomeDownload: {
            type: String,
            default: '',
        },
    },

    data: () => ({
        imagem: null,
        key: null,
        isDragging: false,
    }),

    watch: {
        value(v) {
            this.setImagem(v);
        },
    },

    created() {
        this.key = this.randomKeyGenerate();
    },

    mounted() {
        this.setImagem(this.value);
    },

    methods: {
        setImagem(value) {
            if (!value?.url && !value?.length) {
                this.imagem = null;
                this.$refs[`image-${this.key}`].value = null;
                return;
            }
            value?.length && (this.imagem = value[value.length - 1]);
            value?.url && (this.imagem = value);
        },

        clear() {
            this.imagem = null;
            this.$refs[`image-${this.key}`].value = null;
            this.$emit('input', null);
        },

        getUrl() {
            if (!this.imagem?.url) {
                return '';
            }

            const url = this.imagem.tmp
                ? `${this.$urlAPI}/files/tmp/${this.imagem.url}`
                : `${this.$urlAPI}/storage/${this.imagem.url}`;

            return url;
        },

        async uploader(e) {
            const files = e.target.files || e.dataTransfer.files;

            if (files.length === 0) return;

            try {
                const urlUpload = `${this.$urlAPI}/files/upload`;
                const file = files[0];
                const isGif = file.type === 'image/gif';

                const shouldResize = !isGif && this.autoResize;

                const blob = shouldResize ? await resize(file, 400) : file;

                // Se o blob foi convertido de PNG para JPEG, ajusta a extensão do nome
                const wasConverted = file.type === 'image/png' && blob.type === 'image/jpeg';
                const fileName = wasConverted
                    ? file.name.replace(/\.png$/i, '.jpg')
                    : file.name;

                const newFile = new File([blob], fileName, { type: blob.type });

                const body = new FormData();
                body.append('file', newFile);
                const resp = await fetch(urlUpload, {
                    method: 'POST',
                    headers: {
                        authorization: `Bearer ${auth.token()}`,
                    },
                    body,
                });

                const name = file.name.split('.');
                name.pop();

                const dataResp = await resp.json();

                this.$emit('input', {
                    descricao: name.join('.'),
                    file: file,
                    fileName: file.name,
                    tmp: true,
                    url: dataResp.path,
                });
            } finally {
                //
            }
        },

        baixar() {
            const nome = this.nomeDownload || this.imagem.descricao || 'imagem';
            const link = document.createElement('a');

            if (this.imagem.file instanceof File) {
                // Ainda não salva: baixa o arquivo escolhido, direto do navegador
                link.href = URL.createObjectURL(this.imagem.file);
                link.download = this.imagem.fileName || nome;
            } else {
                // Em outra aba: se a API devolver erro, o cadastro aberto não é perdido
                link.href = `${this.$urlAPI}/storage-download/${this.imagem.url}?nome=${encodeURIComponent(nome)}`;
                link.target = '_blank';
                link.rel = 'noopener';
            }

            link.click();
            link.href.startsWith('blob:') && setTimeout(() => URL.revokeObjectURL(link.href), 1000);
        },

        handleDrop(event) {
            event.preventDefault();
            this.handleDragLeave();
            this.uploader(event);
        },

        handleDragOver() {
            this.isDragging = true;
        },

        handleDragLeave() {
            this.isDragging = false;
        },

        randomKeyGenerate() {
            let caracteres = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            let key = '';
            for (let i = 0; i < 8; i++) {
                key += caracteres.charAt(Math.floor(Math.random() * caracteres.length));
            }
            return key;
        },
    }
}
</script>

<style scoped>
input[type="file"] {
    display: none;
}

label {
    padding: 10px 10px;
    width: 130px;
    height: 44px;
    background-color: #333;
    color: #FFF;
    text-transform: uppercase;
    text-align: center;
    display: block;
    margin-top: 25px;
    cursor: pointer;
}

.btn-image {
    border-radius: 5px;
}

.flex-image-container {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-around;
}

.drag-over {
    border: 2px dashed #000;
}
</style>
